import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Label, Icon, Popup } from 'semantic-ui-react';
import i18next from 'i18next';
import ItemImage from '../menu/ItemImage';
import CurrencyFormat from '../../general/CurrencyFormat';
import { PIZZA_COVERS } from '../../../config';

import './SelectionItem.scss';

const SelectionItem = ({ item, count, builderType, onSelected, ...props }) => {
    function renderBuilder() {
        if (builderType === 'multi') {
            return (
                <Button.Content className="multi-builder" hidden onClick={e => e.stopPropagation()}>
                    <span onClick={() => onSelected(item.id, -1)}>−</span>
                    <label>{`x${count}`}</label>
                    <span onClick={() => onSelected(item.id, 1)}>+</span>
                </Button.Content>
            );
        }
        if (builderType === 'pizza') {
            return (
                <Button.Content className="multi-builder" hidden onClick={e => e.stopPropagation()}>
                    {item.parts.map((part, index) => {
                        const isSelected = item.selectedPart === index;
                        return (
                            <span
                                key={index}
                                className={isSelected ? 'selected pizza' : 'pizza'}
                                onClick={() => onSelected(part.id, isSelected ? -1 : 1)}
                            >
                                {PIZZA_COVERS[index]}
                                <br />
                                <span>{i18next.t(`menu.pizzaCover.${index}`)}</span>
                            </span>
                        );
                    })}
                </Button.Content>
            );
        }
    }

    function renderSelectionIndicator() {
        if (count && builderType) {
            let indicator = `x${count}`;
            if (builderType === 'pizza') {
                indicator = PIZZA_COVERS[item.selectedPart];
            }

            return <span className="selection-indicator">{indicator}</span>;
        }
    }

    function renderContent() {
        return (
            <Button.Content style={{ display: 'flex' }}>
                {renderSelectionIndicator()}
                <span className="title">{item.name}</span>
                {!['multi', 'pizza'].includes(builderType) && item.description && <Popup content={item.description} trigger={<Icon name="info circle" className="info-icon"/>} />}
                {item.price ? <CurrencyFormat className="price" amount={item.price} /> : null}
            </Button.Content>
        );
    }

    function renderContentWithImage(active) {
        return (
            <Fragment>
                <Button secondary basic={!active}>
                    {renderContent()}
                </Button>
                <Label style={{ borderColor: 'var(--secondary-color)', padding: 0 }} basic>
                    <ItemImage src={item.imageUrl} />
                </Label>
            </Fragment>
        );
    }

    const isActive = count > 0;

    return (
        <Button
            secondary
            as='div'
            basic={!isActive}
            labelPosition={item.imageUrl && 'right'}
            animated={builderType && 'fade'}
            className="pi selection-item"
            onClick={() => onSelected(item.id, count ? -1 : 1)}
            tabIndex=""
        >
            {item.imageUrl ? renderContentWithImage(isActive) : renderContent()}
            {renderBuilder()}
        </Button>
    );
};

SelectionItem.propTypes = {
    item: PropTypes.object,
    count: PropTypes.number,
    builderType: PropTypes.string,
    onSelected: PropTypes.func
};

export default SelectionItem;
